import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import {ModalDetailComponent} from '../modal-detail/modal-detail.component';

@Component({
  selector: 'app-modal-invoice-pdf',
  templateUrl: './modal-invoice-pdf.component.html',
  styleUrls: ['./modal-invoice-pdf.component.scss']
})
export class ModalInvoicePdfComponent implements OnInit {
  userId: any;
  userToken: any;
  textButton: any;
  loadBtn = false;
  type: any;
  info: any = {};
  listCompanies: any;
  editId: any;
  order: any;

  constructor(private toastr: ToastrService, public dialog: MatDialog, public dialogRef: MatDialogRef<ModalInvoicePdfComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.type = this.data.type;
    this.order = this.data.order;

    if(this.type === 'order-open'){
      this.textButton = 'Proporcionar la información';
    }else{
      this.editId = this.data.id;
      this.textButton = 'EDITOFFICE';
    }
  }

  ngOnInit() {
  }

  validFile(evt){
    const file = evt.dataTransfer ? evt.dataTransfer.files[0] : evt.target.files[0];
    const pattern = /image-*/;
    const patternPdf = /pdf/;
    const reader = new FileReader();

    if (!file.type.match(patternPdf)) {
      this.toastr.error('Formato de archivo inválido, solo se acepta PDF', 'Error');
      return false;
    }

    this.info.invoice = evt.srcElement.files[0].name;
    reader.onload = this.loadedCedula.bind(this);
    reader.readAsBinaryString(file);
  }

  loadedCedula(readerEvt) {
    const binaryString = readerEvt.target.result;
    const base64textString = btoa(binaryString);
    this.info.invoice_base64 = 'data:application/pdf;base64,'+base64textString;
  }

  viewFile(url){
    let type = 'view_jpg';
    const last = url.split('.').pop();
    if(last == 'pdf'){
      type = 'view_pdf';
    }

    console.log(url, type);
    this.dialog.open(ModalDetailComponent, {
      minWidth: '50%',
      position: {
        top: '6%'
      },
      data: {type: type, url: url, title: 'Documento'}
    });
  }

  onCloseConfirm() {
    this.dialogRef.close({ data: true });
  }

  onCloseCancel() {
    this.dialogRef.close();
  }

}
